import React from "react";

const Experience = () => {

    const roles = [
        {
            company: "Ochrebyte Technology",
            role: "Unity Game Developer",
            duration: "Oct 2024 – Present",
            desc: "Led gameplay and UI feature development for casino lines (Slots, Keno, Lottery). Designed reusable gameplay systems, built lobby and reward flows, integrated APIs and monetization, and optimized mobile/WebGL builds.",
            color: "arcade-cyan"
        },
        {
            company: "Pasakasa Creations",
            role: "Unity Developer",
            duration: "Oct 2022 – Oct 2024",
            desc: "Built modular systems and gameplay frameworks for hybrid-casual and casino mechanics. Developed game flows, UI elements, animations, and reusable tools across multiple prototypes.",
            color: "arcade-magenta"
        },
        {
            company: "Sharelook",
            role: "Unity Developer (Contract)",
            duration: "Jun 2024 – Oct 2024",
            desc: "Primary Unity developer for 3D mini-games (runner, helix, shooting, quiz). Implemented modular gameplay logic, UI systems, and performed profiling/optimization for mobile.",
            color: "arcade-yellow"
        },
        {
            company: "AITC International",
            role: "Gameplay Developer",
            duration: "Apr 2022 – Apr 2024",
            desc: "Implemented gameplay systems, UI flows, and Photon network integrations. Contributed to testing, debugging, and technical documentation during iterative feature development.",
            color: "neon-green"
        },
        {
            company: "GrayCode Technology",
            role: "Full Stack .NET Developer",
            duration: "Mar 2021 – Apr 2022",
            desc: "Developed ERP, finance, and e-commerce platforms using ASP.NET and C#. Built REST APIs and backend modules, and improved database and backend performance through refactoring.",
            color: "arcade-cyan"
        },
        {
            company: "HammerLab Creations",
            role: "Unity Developer (Entry Level)",
            duration: "Aug 2018 – Aug 2019",
            desc: "Learned Unity fundamentals and built puzzle and hyper-casual prototypes focusing on gameplay scripting and level mechanics.",
            color: "arcade-magenta"
        },
        {
            company: "Chisotatto",
            role: "Founder & Creative Lead (Part-Time)",
            duration: "Oct 2023 – Present",
            desc: "Oversees product concept direction, UI/UX decisions, and supports creative content and branding strategy.",
            color: "arcade-yellow"
        }
    ];

    return (
        <section id="experience" className="py-20 md:py-28 transition-colors duration-300">
            <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
                <div className="mb-12 text-center">
                    <div className="flex items-center justify-center gap-3 mb-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-7 h-7 text-arcade-cyan" fill="none">
                            <path d="M3 12c0-4 3-7 7-7h4c4 0 7 3 7 7v0" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" opacity="0.95" />
                            <circle cx="9" cy="13" r="0.9" fill="currentColor" />
                            <circle cx="15" cy="13" r="0.9" fill="currentColor" />
                        </svg>
                        <h2 className="text-4xl md:text-5xl font-bold mb-0">Professional Experience</h2>
                    </div>
                    <p className="text-lg text-gray-600 dark:text-gray-400">~4 years of professional experience across gameplay systems, UI/UX, and game development</p>
                </div>

                <div className="space-y-4 md:space-y-6">
                    {roles.map((exp, idx) => (
                        <div key={idx} className="bg-white dark:bg-gray-800 p-6 rounded-xl border border-gray-200 dark:border-gray-700 shadow-md hover:shadow-lg transition-shadow duration-300">
                            <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-3 mb-3">
                                <div>
                                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-gray-100">{exp.company}</h3>
                                    <p className="text-base md:text-lg text-blue-600 dark:text-blue-400 font-medium">{exp.role}</p>
                                </div>
                                <span className="text-sm md:text-base text-gray-500 dark:text-gray-400 font-medium">{exp.duration}</span>
                            </div>
                            <p className="text-base md:text-lg text-gray-700 dark:text-gray-300 leading-relaxed">{exp.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
